var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-content"},[_c('div',{staticClass:"c-content-wrap",on:{"click":_vm.handleHref}},[_c('div',{staticClass:"c-content-html",domProps:{"innerHTML":_vm._s(_vm.finalContent)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }